import request from "@utils/request";

export function getBridge(query) {
    return request({
        url: 'option/bridge',
        method: 'get',
        params: query
    })
}
